import * as Cell from "./Cell";
import beth from "../img/beth.jpg";
import green from "../img/green.jpg";
import morty from "../img/morty.jpg";
import Rick from "../img/Rick-and-Morty-Doaly.jpg";
import rick from "../img/rick-and-morty.jpg";
import bad from "../img/bad.jpg";

export let initialBoard = [
  { symbol: beth, status: Cell.Status.Closed },
  { symbol: green, status: Cell.Status.Closed },
  { symbol: morty, status: Cell.Status.Closed },
  { symbol: Rick, status: Cell.Status.Closed },
  { symbol: rick, status: Cell.Status.Closed },
  { symbol: bad, status: Cell.Status.Closed },
  { symbol: beth, status: Cell.Status.Closed },
  { symbol: green, status: Cell.Status.Closed },
  { symbol: morty, status: Cell.Status.Closed },
  { symbol: Rick, status: Cell.Status.Closed },
  { symbol: rick, status: Cell.Status.Closed },
  { symbol: bad, status: Cell.Status.Closed },

];
